import { Text } from "@alpacahq/ui/old";

export const AssetNotFound = () => (
  <div className="flex items-center justify-center pt-12 pr-6 pb-6 pl-6 xs:pl-0">
    <div>
      <div>
        <img src="resources/images/asset-not-found.svg" alt="Asset Not Found" />
      </div>
      <Text className="text-center font-semibold text-xl">Asset not found</Text>
      <Text className="text-gray-400">
        Use the Search bar to find assets available to trade
      </Text>
    </div>
  </div>
);
